import React, { useState, Fragment } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Label,
  FormFeedback,
} from "reactstrap";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { applyCoupon } from "../../../slices/apps/companySlice";

const ApplyCouponModal = ({ companyId, onSuccess }) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [inputError, setInputError] = useState("");

  const { applyCouponLoading } = useSelector(
    (state) => ({
      applyCouponLoading: state.company.applyCouponLoading,
    }),
    shallowEqual
  );

  const toggle = () => {
    setModal(!modal);
    if (!modal) {
      setCouponCode("");
      setInputError("");
    }
  };

  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) {
      setInputError("Lütfen bir kupon kodu giriniz.");
      return;
    }

    setInputError("");

    const payload = {
      couponCode: couponCode.trim(),
      usedCompanyId: companyId,
    };

    try {
      await dispatch(applyCoupon(payload)).unwrap();

      toggle();
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      /* Silently handled */
    }
  };

  return (
    <Fragment>
      <Button
        className="btn btn-label btn"
        color="success"
        type="button"
        onClick={toggle}
      >
        <i className="ri-ticket-line label-icon align-middle me-2"></i> Kupon
        Kullan
      </Button>

      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalHeader className="border-bottom-0" toggle={toggle}>
          Kupon Kullan
        </ModalHeader>

        <ModalBody className="py-3 px-4">
          <div className="mt-2 text-center">
            <div className="mb-4">
              <i className="ri-coupon-3-line display-4 text-success"></i>
            </div>

            <div className="text-start">
              <Label htmlFor="couponCodeInput" className="form-label">
                Kupon Kodu
              </Label>
              <Input
                type="text"
                id="couponCodeInput"
                className="form-control"
                placeholder="Kupon kodunu buraya giriniz..."
                maxLength={50}
                value={couponCode}
                onChange={(e) => {
                  setCouponCode(e.target.value);
                  if (inputError) setInputError("");
                }}
                invalid={!!inputError}
              />
              {inputError && <FormFeedback>{inputError}</FormFeedback>}
              <p className="text-muted fs-12 mt-2">
                *Kupon kodu kullanıldığında ilgili tutar firma hesabına
                yansıtılacaktır.
              </p>
            </div>

            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
              <Button
                color="success"
                className="w-sm"
                onClick={handleApplyCoupon}
                disabled={applyCouponLoading}
              >
                {applyCouponLoading ? "İşleniyor..." : "Onayla ve Kullan"}
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default ApplyCouponModal;
